import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";
import { ICenter } from "../../../../../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center/ICenter";

export const CentreMasterDeleteSlice = createSlice({
  name: "CentreMasterDeleteSlice",
  initialState: {} as IReduxState<ICenter>,
  reducers: {
    centreMasterDelete: (state, _) => {
      state.isLoading = true;
    },
    successCentreMasterDelete: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterDelete: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterDelete: (state) => {
      state.data = {};
    },
  },
});

export const {
  centreMasterDelete,
  successCentreMasterDelete,
  failureCentreMasterDelete,
  clearCentreMasterDelete,
} = CentreMasterDeleteSlice.actions;

export default CentreMasterDeleteSlice.reducer;
